/* EQ State — restrict the product-card image hover effects to the image itself.
   Dawn triggers the secondary-image swap and the 1.03 zoom from `.card-wrapper:hover`,
   i.e. the whole card, so hovering the title, price, format toggle or Add to cart
   button also swapped the picture. Scoping it in pure CSS is not possible here:
   `.card__heading a::after` is an inset-0, z-index-1 overlay covering the entire
   card, so the pointer is never actually over `.card__media` and a
   `.card__media:hover` rule would never fire. Instead we hit-test the cursor
   against the media box and toggle `.eqx-media-hover`, which component-card.css
   now keys the effects off. Desktop only — the CSS lives in a min-width:990px
   block and pointer devices are the only ones that hover. */
(() => {
  const CLASS = 'eqx-media-hover';
  let hovered = null;
  let lastX = -1;
  let lastY = -1;

  const clear = () => {
    if (!hovered) return;
    hovered.classList.remove(CLASS);
    const card = hovered.querySelector('.card');
    if (card) card.classList.remove(CLASS);
    hovered = null;
  };

  const apply = (wrapper, inside) => {
    if (!inside) {
      clear();
      return;
    }
    if (hovered !== wrapper) clear();
    wrapper.classList.add(CLASS);
    const card = wrapper.querySelector('.card');
    if (card) card.classList.add(CLASS);
    hovered = wrapper;
  };

  const evaluate = (x, y, target) => {
    // Delegated rather than bound per card: Dawn replaces the whole grid on
    // facet filtering and pagination, so per-card listeners would be lost.
    const wrapper = target && target.closest ? target.closest('.card-wrapper') : null;
    if (!wrapper) {
      clear();
      return;
    }
    const media = wrapper.querySelector('.card__media');
    if (!media) {
      clear();
      return;
    }
    const r = media.getBoundingClientRect();
    apply(wrapper, x >= r.left && x <= r.right && y >= r.top && y <= r.bottom);
  };

  document.addEventListener(
    'mousemove',
    (event) => {
      lastX = event.clientX;
      lastY = event.clientY;
      evaluate(lastX, lastY, event.target);
    },
    { passive: true }
  );

  // The cursor can end up over a different part of the card without moving,
  // if the page scrolls underneath it.
  document.addEventListener(
    'scroll',
    () => {
      if (lastX < 0 || !hovered) return;
      evaluate(lastX, lastY, document.elementFromPoint(lastX, lastY));
    },
    { passive: true }
  );

  document.addEventListener('mouseleave', clear);
})();
